import React from 'react';
import { useTranslation } from 'react-i18next';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, EndpointDoc } from '../../../components/apidocs';
import { BALANCE_ENDPOINTS } from '../data/balance';

const BalanceSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionTitle icon={faWallet} iconColor="bg-gradient-to-br from-indigo-400 to-violet-500">
        Balance API
      </SectionTitle>
      <p className="text-gray-500 dark:text-slate-400 mb-5 text-sm">{t('apiDocs.balanceApiDesc')}</p>

      {BALANCE_ENDPOINTS(t).map((spec, idx) => <EndpointDoc key={idx} {...spec} />)}
    </div>
  );
};

export default BalanceSection;
